import * as Yup from 'yup';
import { EMAIL_REG_EX, PHONE_REG_EX } from '../utils/regex';
import { get } from 'lodash';
import {
  CREATE_LINKED_MANAGED_BY_OPTIONS,
  PARTNER_RELATIONSHIP,
} from '../utils/constant';
import {
  INSTANCE_PHONE_REG_EX,
  INSTANCE_PHONE_MIN_LENGTH,
} from '../utils/instanceConstant';

export const getOwnerDetailsInitialValues = (
  activity,
  currentUserEmail = null
) => {
  return {
    // firstName: get(activityOwner, 'firstName', ''),
    email: currentUserEmail ? currentUserEmail : '',
    // surname: get(activityOwner, 'surname', ''),
    // entityName: get(activityOwner, 'organisation.name', ''),
    // address1: get(activityOwner, 'address1', ''),
    // address2: get(activityOwner, 'address2', ''),
    // suburb: get(activityOwner, 'suburb', ''),
    // state: get(activityOwner, 'state', ''),
    // postcode: get(activityOwner, 'postcode', ''),
    // phone: get(activityOwner, 'phone', ''),
    // abn: get(activityOwner, 'abn', ''),
    // acn: get(activityOwner, 'acn', ''),
    // organisationId: get(activityOwner, 'organisationId', null),
    // organisationName: get(activityOwner, 'organisation.name', ''),
    // // programContribution: get(partnerDetails, 'relationship', ''),
    // isExistingUser: true,
    // isConfirmedUser: true,
    projectedGrantAmount: get(activity, 'projectedGrantAmount', null),
    relationship: PARTNER_RELATIONSHIP[0].value,
    managedBy: CREATE_LINKED_MANAGED_BY_OPTIONS()[0].value,
    // description: get(activity, 'description', ''),
    // emailConfirmError: activityOwner ? 'confirmedUser' : '',
  };
};

export const changeOwnershipValidationSchema = (t, orgUsersEmails) =>
  Yup.lazy((values) => {
    let validationSchema = {
      email: Yup.string()
        .required(t('formulary.validation.activity_manager_required'))
        .matches(EMAIL_REG_EX, t('formulary.validation.email_not_valid')),
      emailConfirmError:
        values.managedBy === CREATE_LINKED_MANAGED_BY_OPTIONS()[2].value &&
        !values.isConfirmedUser
          ? Yup.string().required(
              t('formulary.validation.confirmation_required')
            )
          : Yup.string().optional(),
      managedBy: Yup.string()
        .oneOf(CREATE_LINKED_MANAGED_BY_OPTIONS().map((item) => item.value))
        .required(),
    };

    // for existing user + org user
    if (values.managedBy === CREATE_LINKED_MANAGED_BY_OPTIONS()[2].value) {
      validationSchema = {
        ...validationSchema,
        email: Yup.string()
          .notOneOf(
            orgUsersEmails,
            t(
              'formulary.validation.unable_to_invite_organisation_user_as_external'
            )
          )
          .required(t('formulary.validation.activity_manager_required'))
          .matches(EMAIL_REG_EX, t('formulary.validation.email_not_valid')),
      };
    }

    if (
      values.managedBy === CREATE_LINKED_MANAGED_BY_OPTIONS()[2].value &&
      !values.isExistingUser
    ) {
      validationSchema = {
        ...validationSchema,
        firstName: Yup.string().required(
          t('formulary.validation.first_name_required')
        ),
        surname: Yup.string().required(
          t('formulary.validation.last_name_required')
        ),
        phone: Yup.string()
          .required(t('formulary.validation.phone_number_required'))
          .matches(
            INSTANCE_PHONE_REG_EX,
            t('formulary.validation.please_enter_the_valid_format')
          )
          .min(
            INSTANCE_PHONE_MIN_LENGTH,
            t('formulary.validation.must_be_a_minimum_of_digits', {
              count: INSTANCE_PHONE_MIN_LENGTH,
            })
          ),

        entityName: Yup.string().required(
          t('formulary.validation.business_organisation_name_required')
        ),
        address1: Yup.string().required(
          t('formulary.validation.address_line_1_required')
        ),
        suburb: Yup.string().required(
          t('formulary.validation.suburb_required')
        ),
        state: Yup.string().required(t('formulary.validation.state_required')),
        postcode: Yup.string().required(
          t('formulary.validation.postcode_required')
        ),
      };
    }

    return Yup.object().shape(validationSchema);
  });
